import { MULTI_APP_PARAM } from '../constants/multiApp';

/**
 * Builds a location descriptor with `multiApp` removed from the query string.
 * @param {{ pathname?: string, search?: string, hash?: string }} location
 * @returns {{ pathname: string, search: string, hash: string }}
 */
export const clearMultiAppFromLocation = (location = {}) => {
  const params = new URLSearchParams(location.search || '');
  params.delete(MULTI_APP_PARAM);
  const nextSearch = params.toString();

  return {
    pathname: location.pathname || '/',
    search: nextSearch ? `?${nextSearch}` : '',
    hash: location.hash || ''
  };
};
